module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921124149_T.6dbc3457.jpg";